import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';

let url = process.env.REACT_APP_API_URL;

export const salesNotificationService = {
  getSalesNotifications: async (params) => {
    const response = await authInstance
      .get(
        `${url}/salesNotif/list?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      });
    return response;
  },

  putSalesNotification: async (notificationId, data) => {
    const response = await authInstance
      .put(`${url}/salesNotif/${notificationId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getSalesNotificationCount: async () => {
    const response = await authInstance
      .get(`${url}/salesNotif/count`)
      .then((response) => response)
      .catch(() => ({ data: 0 }));
    return response;
  },

  showAllNotifications: async (data) => {
    const response = await authInstance
      .put(`${url}/salesNotif/showAll`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
